import { createGlobalStyle } from 'styled-components';

export const GlobalScrollLock = createGlobalStyle`
  html {
    overflow: hidden !important;
  }
`;
